import { useEffect } from 'react';

const DEFAULT_TITLE = 'Noora Privé | Butik Kadın Giyim & Aksesuar Online Mağaza';
const DEFAULT_DESC = 'Noora Privé online butik kadın giyim mağazası. Elbise, bluz, dış giyim, takım, aksesuar ve şal koleksiyonları. Şık tasarım, kaliteli kumaş, hızlı kargo, güvenli ödeme.';
const DEFAULT_IMAGE = 'https://nooraprive.com/logo_noora.png';

export default function useSeo({ title, description, keywords, canonical, image } = {}) {
    useEffect(() => {
        // Title
        document.title = title || DEFAULT_TITLE;

        // Description
        let metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) metaDesc.setAttribute('content', description || DEFAULT_DESC);

        // Keywords
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords && keywords) metaKeywords.setAttribute('content', keywords);

        // OG tags
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute('content', title || DEFAULT_TITLE);
        const ogDesc = document.querySelector('meta[property="og:description"]');
        if (ogDesc) ogDesc.setAttribute('content', description || DEFAULT_DESC);

        // OG image
        const ogImage = document.querySelector('meta[property="og:image"]');
        if (ogImage) ogImage.setAttribute('content', image || DEFAULT_IMAGE);

        // OG url
        const ogUrl = document.querySelector('meta[property="og:url"]');
        if (ogUrl) ogUrl.setAttribute('content', canonical || window.location.href);

        // Twitter tags
        const twTitle = document.querySelector('meta[name="twitter:title"]');
        if (twTitle) twTitle.setAttribute('content', title || DEFAULT_TITLE);
        const twDesc = document.querySelector('meta[name="twitter:description"]');
        if (twDesc) twDesc.setAttribute('content', description || DEFAULT_DESC);
        const twImage = document.querySelector('meta[name="twitter:image"]');
        if (twImage) twImage.setAttribute('content', image || DEFAULT_IMAGE);

        // Canonical
        let link = document.querySelector('link[rel="canonical"]');
        if (link && canonical) link.setAttribute('href', canonical);

        return () => {
            document.title = DEFAULT_TITLE;
            if (metaDesc) metaDesc.setAttribute('content', DEFAULT_DESC);
            if (ogImage) ogImage.setAttribute('content', DEFAULT_IMAGE);
        };
    }, [title, description, keywords, canonical, image]);
}
